import { createFileRoute } from "@tanstack/react-router";

import { AccountsTab } from "@/features/wonda/components/AccountsTab";

export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/account/accounts",
)({
  component: AccountsTab,
});
